import React from 'react';

export default function LongTextInput(props) {
  const id = props.id || 'editor-' + props.name;
  const value = props.value === 0 || props.value ? props.value : '';
  const cols = props.cols || 132;
  const rows = props.rows || 5;
  const onChange = function (e) {
    const newValue = e.target.value;
    if (props.onChange) props.onChange({name: props.name, value: newValue});
    else console.log(props.name, e.target.value);
  };
  let formGroupClassName = 'form-group';
  if (props.error) formGroupClassName += ' has-error';
  const label = props.label === null ? null : (
    <label htmlFor={id} style={{display: 'block'}}>
      {props.label || props.name}
    </label>
  );
  const message = props.error || props.message;
  return (
    <div className={formGroupClassName}>
      {label}
      <textarea
        className="form-control"
        value={value}
        onChange={onChange}
        name={props.name}
        cols={cols}
        rows={rows}
      />
      <span className="help-block">{message}</span>
    </div>
  );
};



// WEBPACK FOOTER //
// ../hyperdb-utils/src/components/ui-react/LongTextInput.jsx